/* eslint-disable */
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import Services from './components/Services';
import Careers from './components/Careers';
import Home from './components/Home';
import "bootstrap-icons/font/bootstrap-icons.css";
import ScrollTop from './components/ScrollTop';
import '../src/style/Font.css'
import TopButton from './components/TopButton';
function App() {
  
  return (
    <>
    <BrowserRouter>
      <ScrollTop/>
      <TopButton/>
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/about' element={<AboutUs/>}/>
      <Route path='/contact' element={<ContactUs/>}/>
      <Route path='/services' element={<Services/>}/>
      <Route path='/careers' element={<Careers/>}/>
    </Routes>
    </BrowserRouter>
    {/* <HomePage/> */}
    </>
  );
}

export default App;
